import React, { Component } from 'react';
import { Modal } from 'antd';
import { observer, inject } from 'mobx-react';

@inject('appStrategyStore')
@observer
class SyncAccrossVersionsModal extends Component {
  constructor(props) {
    super(props);
    this.okFunc = this.okFunc.bind(this);
  }
  okFunc() {
    const {
      hideSyncAcrossVersionModal,
      SyncAcrossVersionData,
      postStrategyProgress
    } = this.props.appStrategyStore;
    postStrategyProgress(
      SyncAcrossVersionData.id,
      !SyncAcrossVersionData.isCheck + '',
      SyncAcrossVersionData.time
    );
    hideSyncAcrossVersionModal();
  }
  render() {
    const {
      SyncAcrossVersionModal,
      hideSyncAcrossVersionModal
    } = this.props.appStrategyStore;
    return (
      <div>
        <Modal
          visible={SyncAcrossVersionModal}
          onOk={this.okFunc}
          onCancel={hideSyncAcrossVersionModal}
          width={'50%'}
        >
          当前操作存在跨版本升级情况，您确定这样进行么?
        </Modal>
      </div>
    );
  }
}

export default SyncAccrossVersionsModal;



// WEBPACK FOOTER //
// ./src/components/AppStrategy/SyncAcrossVersionsModal.js